import { Box } from "@mui/material";
import { formatMonth } from "common/functions/utilities";
import { UseDistrictProperty } from "common/interfaces/UseDistrictGeoJSON";
import { EstateType } from "graphql/API";
import React, { useMemo } from "react";
import { ContentBasic } from "./ContentBasic";
import { ContentTail } from "./ContentTail";
import { ContentWrapper } from "./ContentWrapper";
import styles from "./DetailPage.subComponents.module.scss";

export const GroundContent = React.memo(
  (props: {
    estate?: EstateType;
    eSchools?: string[];
    jSchools?: string[];
    useDistricts?: Partial<UseDistrictProperty>[];
    roadInfos: string[];
  }) => {
    const road = useMemo(() => {
      const roadStr = props.roadInfos.filter((x) => x !== "").join(" / ");

      return roadStr === "" ? null : roadStr;
    }, [props.roadInfos]);

    const groundType = useMemo(() => {
      const groundTypeStr = [
        props.estate?.groundType,
        props.estate?.groundTypeFree
      ]
        .filter((x) => x)
        .join(", ");

      return groundTypeStr === "" ? null : groundTypeStr;
    }, [props.estate?.groundType, props.estate?.groundTypeFree]);

    const currentStatus = useMemo(() => {
      const currentStatusStr = [
        props.estate?.currentStatus,
        props.estate?.currentStatusFree
      ]
        .filter((x) => x)
        .join(", ");

      return currentStatusStr === "" ? null : currentStatusStr;
    }, [props.estate?.currentStatus, props.estate?.currentStatusFree]);

    return (
      <ContentWrapper>
        <Box className={styles.name}>
          <strong>{props.estate?.estateType}</strong>
        </Box>

        <Box className={`${styles.price} ${styles.ground}`}>
          <Box>価格</Box>
          <Box>{props.estate?.estatePrice ?? "−"} 万円</Box>
          <Box>坪単価</Box>
          <Box>{props.estate?.unitPrice ?? "−"} 万円</Box>
        </Box>

        <ContentBasic estate={props.estate} />

        <Box className={styles.area}>
          <Box>土地面積</Box>
          <Box>{props.estate?.tsuboArea ?? "−"} 坪</Box>
        </Box>

        <Box className={styles.road}>
          <Box>道路</Box>
          <Box>{road ?? "−"}</Box>
        </Box>

        <Box className={`${styles.conditions} ${styles.ground}`}>
          <Box>地目</Box>
          <Box>{groundType ?? "−"}</Box>
          <Box>現況</Box>
          <Box>{currentStatus ?? "−"}</Box>
        </Box>

        <Box
          className={`${styles.conditions} ${styles.ground} ${styles.additional}`}
        >
          <Box>建築条件</Box>
          <Box>{props.estate?.bldConditionType ?? "−"}</Box>

          <Box>完成</Box>
          <Box>
            {props.estate?.completionMonth
              ? formatMonth(props.estate?.completionMonth)
              : props.estate?.completionSchMonth
                ? `${formatMonth(props.estate?.completionSchMonth)} 予定`
                : "−"}
          </Box>
        </Box>

        <ContentTail
          estate={props.estate}
          eSchools={props.eSchools}
          jSchools={props.jSchools}
          useDistricts={props.useDistricts}
        />

        <Box className={`${styles.memo} ${styles.ground}`}>
          <Box>メモ</Box>
          <Box></Box>
        </Box>
      </ContentWrapper>
    );
  }
);
